import condenseIcon from "../../assets/imgs/condense-icon.png";

// Exact play+leaf mark from VideoBrief (logo512), recolored green for Condense.
export default function CondenseIconMark({ size = 28, className = "" }) {
  return (
    <img
      src={condenseIcon}
      alt=""
      aria-hidden="true"
      className={className}
      style={{ width: size, height: size, flexShrink: 0, display: "block" }}
    />
  );
}
